// extracted by mini-css-extract-plugin
export default {"fileBox":"tWLDUCXAUx38c41052Uc"};